import { FilterAlt, Visibility } from "@mui/icons-material";
import {
    Button,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { toast } from "react-toastify";

const ResetPassword = () => {
 const [vendorData,setVendorData]=useState([])
 const [email,setEmail]=useState("")
 const [currentPass,setCurrentPAss]=useState("")
 const [newPass,setNewPass]=useState("")
    
  const vendorDataList = () => {
    axios
      .post(
        `https://app1.crazzyhub.com/api/multivendor-vendor-list-data/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setVendorData(response?.data?.vendor_list_data);
        
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };
  useEffect(() => {
    vendorDataList();
  }, []);

  
  const resetPassData=()=>{
    const fd=new FormData()
    fd.append("email",email)
    fd.append("cpassword",currentPass)
    fd.append("password",newPass)
    axios
      .post(
        `https://app1.crazzyhub.com/api/multivendor-reset-password-admin/`,fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message)
        setEmail("")
        setCurrentPAss("")
        setNewPass("")
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  }

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            {/* <p className="text-xl text-black font-bold">Reset Password</p> */}
          </div>
        </div>
        {/* <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2"> */}

        <div className="w-96 mx-auto py-3 border border-gray-400 rounded-lg shadow-sm shadow-blue-900">
          <div className="text-center py-2 underline underline-offset-2">
            Reset Password
          </div>
          <div className="mx-auto text-center">
            <Box sx={{ minWidth: 0 }}>
              <FormControl fullWidth>
                {/* <InputLabel variant="standard" className="!w-44" htmlFor="uncontrolled-native">
                  Select Store
                </InputLabel> */}
                <NativeSelect
                  defaultValue={10}
                  inputProps={{
                    name: "age",
                    id: "uncontrolled-native",
                  }}
                  className="!w-48 mx-auto mt-3"
                  onChange={(event)=>setEmail(event.target.value)}
                >
                  <option value={10}>Select Store</option>
                  {
                    vendorData?.map((elem)=>
                    <option value={elem?.email}>{elem?.store_name}</option>
                    )
                  }
                </NativeSelect>
              </FormControl>
            </Box>
            <TextField
              id="standard-basic"
              label="Current Password"
              variant="standard"
              className="!mt-2"
              onChange={(event)=>setCurrentPAss(event.target.value)}
            />
            <TextField
              id="standard-basic"
              label="New Password"
              variant="standard"
              className="!mt-2"
              onChange={(event)=>setNewPass(event.target.value)}
            />
            <br/>
            <Button variant="contained" className="!my-5" onClick={resetPassData}>Reset password</Button>
          </div>
        </div>

        {/* </div> */}
      </div>
    </>
  );
};

export default ResetPassword;
